/**
 * Created by Andrey Popov on 2/1/22.
 */

const SalePassWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;

        const components = [{
            name: "header",
            class: PassHeader,
            params: {
                bg_json: bundles.salepass.jsons.bg_json,
                pack_json: bundles.salepass.jsons.pack_json,
                decor_json: bundles.salepass.jsons.decor_json,
                json: bundles.salepass.jsons.head_json,
                close: this.close.bind(this),
                passLogic: mission.logic
            }
        }, {
            name: "progress",
            class: PassProgress
        }, {
            name: "tickets",
            class: PassTickets,
            params: { close: this.close.bind(this) }
        }];

        this._super({
            name: "SalePassWindow",
            title: Messages.get("SalePassWindow.title"),
            content: new PassWindowContent({
                components,
                width: cleverapps.styles.SalePassWindow.width,
                styles: cleverapps.styles.SalePassWindow,
                passLogic: mission.logic
            }),
            help: function () {
                cleverapps.focusManager.display({
                    focus: "SalePassGuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow(mission.guideWindow);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },
            foreground: bundles.passforeground.frames.pass_window_foreground_png,
            contentPadding: cleverapps.styles.SalePassWindow.contentPadding,
            closeButton: true,
            noPadding: true,
            styles: cleverapps.styles.SalePassWindow.window
        });
    },

    onShow: function () {
        this._super();
        this.mission.logic.handleShowWindow();
    },

    listBundles: function () {
        return ["salepass"];
    }
});

cleverapps.styles.SalePassWindow = {
    width: 1758,
    height: 874,

    window: {
        Foreground: {
            contentPadding: {
                top: 300
            }
        }
    },

    contentPadding: {
        right: 80
    },

    progress: {
        x: { align: "right", dx: 2 },
        y: { align: "center", dy: -122 }
    },

    header: {
        x: { align: "center", dx: -1 },
        y: { align: "top", dy: -2 }
    },

    tickets: {
        x: { align: "left", dx: -2 },
        y: { align: "center", dy: -118 }
    }
};

cleverapps.styles.PassHeaderPack[Offers.TYPES.SALEPASS] = cleverapps.overrideStyles(cleverapps.styles.PassHeaderPackTemplate, {
    badge: {
        x: { align: "right", dx: 181 },
        y: { align: "center", dy: -8 }
    }
}, true);
